import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react"
import * as React from "react"
import { toast } from "react-toastify"
import { navigate } from "gatsby-link"
import {
  getApiUrl,
  setToken,
  setUserId,
  setUserVerified,
} from "../../utils/loginInfo"
import { colors } from "../colors/colors"
import { AuthButton, AuthHeader, inputStyles } from "./AuthHeader"
import { usePurchasingCTAs } from "./usePurchasingCTAs"

export function Login({fontFamily = "Lato", clickableColor, buttonColor, buttonTextColor, buttonHoverColor, buttonTextHoverColor, title, cta}) {
  const { products, login } = usePurchasingCTAs()
  return (
    <>
      <AuthHeader
        subCta={login?.linkCta}
        subCtaLink={login?.link}
        title={title || "Sign In"}
        subText="Don't have an account?"  
        fontFamily={fontFamily}
        clickableColor={clickableColor}
      />

      <Box maxW="370px" m="30px auto 0">
        <SigninForm fontFamily={fontFamily} clickableColor={clickableColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} buttonHover={{background: buttonHoverColor || '#CEFF1A', color: buttonTextHoverColor || 'rgba(128,0,255,1)'}} submitCTA={cta} />
      </Box>
    </>
  )
}

export function SigninForm({ fontFamily, clickableColor, buttonColor, buttonTextColor, buttonHover, submitCTA }) {
  const { products, login } = usePurchasingCTAs()
  const [showPassword, setShowPassword] = React.useState(false)

  const handleShowClick = () => setShowPassword(!showPassword)

  const [email, setEmail] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [claim, setClaim] = React.useState(false)

  const submitForm = () => {
    if (email && password) {
      fetch(`${getApiUrl()}/user/sign_in`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-M-P": "3",
        },
        body: JSON.stringify({ email: email, password: password }),
      })
        .then(res => res.json())
        .then(response => {
          if (response?.title) {
            return toast.error(response?.title, {
              hideProgressBar: true,
            })
          }

          if (response?.user?.requireAccountClaim) {
            setClaim(true)
            return
          }

          if (response?.user?.id) {
            setUserId(response?.user?.id)
            setUserVerified(response?.user?.isVerified)
          }

          if (!response?.user?.isVerified) {
            return navigate(products.link)
          }

          setToken(response)
          fetch(`${getApiUrl()}/user/subscription`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-M-P": "3",
              Authorization: `Bearer ${response?.accessToken?.token}`,
            },
          })
            .then(res => {
              if (res.status === 200) {
                return res.json()
              }
            })
            .then(response => {
              if (response) {
                if (response?.userSubscription || response?.trialSubscription) {
                  navigate("/account")
                } else {
                  navigate(products.link)
                }
              } else {
                console.log("Issue with logging in")
              }
            })
        })
    }
  }

  return (
    <form
      onSubmit={event => {
        event.preventDefault()
        submitForm()
      }}
    >
      {claim && (
        <Box
          style={{
            backgroundColor: `lightpink`,
            border: `1px solid red`,
            padding: `8px 16px`,
            marginBottom: `16px`,
          }}
        >
          <Text margin="0">
            Sorry your account can only be claimed from the MOJO app. Please{" "}
            <Link
              href="https://yougotmojo.app.link/getmojo"
              textDecoration="underline"
              fontWeight="bold"
            >
              click here
            </Link>{" "}
            to download.
          </Text>
        </Box>
      )}
      <Stack spacing={4}>
        <FormControl>
          <InputGroup>
            <Input
              {...inputStyles}
              type="email"
              placeholder="Email"
              value={email}
              onChange={event => setEmail(event.target.value)}
            />
          </InputGroup>
        </FormControl>
        <FormControl>
          <InputGroup>
            <Input
              {...inputStyles}
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={event => setPassword(event.target.value)}
            />
            <InputRightElement width="4.5rem" top="3px">
              <Button
                color="#AEAEB2"
                bg="none"
                h="1.75rem"
                size="sm"
                onClick={handleShowClick}
              >
                {showPassword ? "Hide" : "Show"}
              </Button>
            </InputRightElement>
          </InputGroup>
          <FormHelperText textAlign="center" style={{fontSize: '13px', marginTop: '20px'}}>
            Forgot Password? Email{" "}
            <Link
              href="mailto:support@mojo.sport"
              target="_blank"
              color={clickableColor || colors.blue}
            >
              {" "}
              support@mojo.sport{" "}
            </Link>
          </FormHelperText>
        </FormControl>
        <AuthButton label={submitCTA || login?.buttonText} buttonColor={buttonColor} buttonTextColor={buttonTextColor} buttonHover={buttonHover} marginTop={'20px'} />
        <Box>
          <Text
            fontSize="13px"
            lineHeight="18px"
            color="#AEAEB2"
            letterSpacing="-0.21px"
            textAlign="center"
            m="0"
            fontFamily={fontFamily}
          >
            By submitting your information you agree to our <br />
            <Link color={clickableColor || colors.blue} href="/terms" target="_blank">
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link color={clickableColor || colors.blue} href="/privacy" target="_blank">
              Privacy Policy
            </Link>
          </Text>
        </Box>
      </Stack>
    </form>
  )
}
